import React from 'react';

const Button = (props) => {
    
    const button = {
        padding: '0px',
        marginRight: '2px',
        border: '0px',
        height: '60px',
        outline: 'none'
    };

   
    return(
        <button className="btn" style={button} onClick={ props.onButtonPress.bind( this, props.action ) } >
            <img src={props.asset} alt=""/>
        </button>
    );
}

export default Button; 


// WEBPACK FOOTER //
// ./src/ControlPanel/Button.js